"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
module.exports = require('./ReactAI').ReactAI;